module.exports = __webpack_public_path__ + "static/media/Animation_start.5e5569b5.mp4";